module.exports = __webpack_public_path__ + "img/become-seller.6f84b19f.png";